import React from "react";
import "./Footer.scss";
const Footer = () => {
  return (
    <div className="footer-container">
      <h1 className="footer-title">HAITHEM HAJRI © 2022</h1>
    </div>
  );
};

export default Footer;
